import { createAction } from 'deox';
import {
  LOGIN_REQUEST,
  LOGIN_SUCCESS,
  LOGIN_FAILURE,
  SIGN_UP_REQUEST,
  SIGN_UP_FAILURE,
  SIGN_UP_SUCCESS,
  RECOVERY_PASSWORD_REQUEST,
  RECOVERY_PASSWORD_FAILURE,
  RECOVERY_PASSWORD_SUCCESS,
  SEND_CODE_REQUEST,
  SEND_CODE_FAILURE,
  SEND_CODE_SUCCESS,
  LoginFormProps,
  SignUpFormProps,
  ResetPasswordFormProps,
  CLEAR_AUTH_ERRORS,
  SET_AUTH_ERRORS,
  RESTORE_PASSWORD_FAILURE,
  RESTORE_PASSWORD_REQUEST,
  RESTORE_PASSWORD_SUCCESS,
  SET_USER_PHONE,
} from './types';

// Login actions
export const loginAction = {
  request: createAction(LOGIN_REQUEST, resolve => (data: LoginFormProps) => resolve(data)),
  success: createAction(LOGIN_SUCCESS),
  failure: createAction(LOGIN_FAILURE, resolve => (error: string) => resolve(error)),
};

// Signup actions
export const signUpAction = {
  request: createAction(SIGN_UP_REQUEST, resolve => (data: SignUpFormProps) => resolve(data)),
  success: createAction(SIGN_UP_SUCCESS),
  failure: createAction(SIGN_UP_FAILURE, resolve => (error: string) => resolve(error)),
};

// Recovery password actions
export const recoveryPasswordAction = {
  request: createAction(
    RECOVERY_PASSWORD_REQUEST,
    resolve => (data: SignUpFormProps) => resolve(data),
  ),
  success: createAction(RECOVERY_PASSWORD_SUCCESS),
  failure: createAction(RECOVERY_PASSWORD_FAILURE, resolve => (error: string) => resolve(error)),
};

// Send code actions
export const sendCodeAction = {
  request: createAction(
    SEND_CODE_REQUEST,
    resolve => (phoneNumber: string) => resolve({ phoneNumber }),
  ),
  success: createAction(SEND_CODE_SUCCESS, resolve => (code: string) => resolve(code)),
  failure: createAction(SEND_CODE_FAILURE, resolve => (error: string) => resolve(error)),
};

// Restore password actions
export const restorePasswordAction = {
  request: createAction(
    RESTORE_PASSWORD_REQUEST,
    resolve => (payload: ResetPasswordFormProps) => resolve(payload),
  ),
  success: createAction(RESTORE_PASSWORD_SUCCESS),
  failure: createAction(RESTORE_PASSWORD_FAILURE, resolve => (error: string) => resolve(error)),
};

// Set auth errors actions
export const setAuthErrorsAction = createAction(
  SET_AUTH_ERRORS,
  resolve => (errors: { login: string | null; signUp: string | null }) => resolve(errors),
);

// Set user phone action
export const setUserPhoneAction = createAction(
  SET_USER_PHONE,
  resolve => (phone: string) => resolve(phone),
);

// Clear auth errors action
export const clearAuthErrorsAction = createAction(CLEAR_AUTH_ERRORS);
